import { DateTimeFormat, DurationFormat, Icon } from '@testsigma/atoms';
import classNames from 'classnames';
import React from 'react';

interface RunResultDurationComponentProps {
  startTime: Date;
  duration: number;
  dateFormat?: 'hh:mm a, d MMM, yyyy' | 'MMM d, yyyy, hh:mm a';
  className?: string;
}

const RunResultDurationComponent: React.FC<RunResultDurationComponentProps> = ({
  startTime,
  duration,
  dateFormat = 'MMM d, yyyy, hh:mm a',
  className,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-col gap-y-2 text-unique-600',
        className,
      )}>
      <div className='truncate basis-full flex flex-row items-center gap-x-1'>
        <Icon name='hourglass-top' className='text-small leading-5' />
        <DurationFormat milliseconds={duration} format={'hh:mm:ss.SSS'} />
      </div>
      <div className='truncate basis-full'>
        <DateTimeFormat date={startTime} format={dateFormat} relative={false} />
      </div>
    </div>
  );
};

export default RunResultDurationComponent;
